import { render, staticRenderFns } from "./MainIcon.vue?vue&type=template&id=fcf7c850&"
import script from "./MainIcon.vue?vue&type=script&lang=js&"
export * from "./MainIcon.vue?vue&type=script&lang=js&"
import style0 from "./MainIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports